module.exports = new __parcel__URL__("bug-and-task-cards-in-a-column.455dfa61.svg").toString();